import ExecutionStateParser from './ExecutionStateParser';

class ExecutionTableRowBuilder {
    private stateParser: ExecutionStateParser;

    constructor() {
        this.stateParser = new ExecutionStateParser();
    }

    build(execution: any) {
        const start = parseFloat(execution.StartTimeStamp) * 1000;
        const end = !isNaN(execution.TimeStamp) ? parseFloat(execution.TimeStamp) * 1000 : execution.TimeStamp;

        const { description, status } = this.stateParser.parseState(execution);

        return {
            id: execution.GUID,
            name: execution.WorkflowName,
            familyId: execution.Family,
            account: execution.AccountCache ? execution.AccountCache.EnvironmentName : 'unknown',
            region: execution.AccountCache && execution.AccountCache.Region ? execution.AccountCache.Region : 'unknown',
            executionPlan: execution.ExecutionPlan ? execution.ExecutionPlan : '',
            executionDescription: description,
            executionStatus: status,
            start,
            end
        };
    }
}

export default ExecutionTableRowBuilder;